import { FormattedMessage } from 'react-intl';

import { DashboardOutlined, RocketOutlined } from '@ant-design/icons';

const icons = {
  DashboardOutlined,
  RocketOutlined
};

const consultantMenu = {
  items: [
    {
      id: 'consultant-group',
      title:"Consultant" ,
      type: 'group',
      children: [
        {
          id: 'consultant-dashboard',
          title:"Dashboard" ,
          type: 'item',
          url: '/consultant',
          icon: icons.DashboardOutlined
        },
        {
          id: 'consultant-tools',
          title:"Tools" ,
          type: 'collapse',
          icon: icons.RocketOutlined,
          children: [
            {
              id: 'consultant-asset-detection',
              title: "Asset Detection (GS)",
              type: 'item',
              url: '/asset-detection-gs'
            },
            {
              id: 'consultant-asset-detection-2',
              title: "Asset Detection" ,
              type: 'item',
              url: '/asset-detection'
            },
            {
              id: 'consultant-pavement-inspection',
              title: "Pavement Inspection" ,
              type: 'item',
              url: '/pavement-inspection'
            },
            {
              id: 'consultant-damage-detection',
              title: "Damage Detection" ,
              type: 'item',
              url: '/damage-detection'
            },
            {
              id: 'consultant-inventory-creator',
              title: "Inventory Creator",
              type: 'item',
              url: '/inventory-creator'
            },
            {
              id: 'consultant-inventory-creator-utility',
              title: 'Inventory Creator (Utility)',
              type: 'item',
              url: '/inventory-creator-utility'
            },
            {
              id: 'consultant-deterioration-modelling',
              title: "Deterioration Modelling" ,
              type: 'item',
              url: '/deterioration-modelling'
            },
            {
              id: 'consultant-esri-integration',
              title: "Esri Integration",
              type: 'item',
              url: '/esri-integration'
            },
            {
              id: 'consultant-building-modelling',
              title: "Building Modelling",
              type: 'item',
              url: '/building-modelling'
            },
            {
              id: 'consultant-building-viewer',
              title: 'Building Viewer',
              type: 'item',
              url: '/building-viewer'
            },
            {
              id: 'consultant-facility-viewer',
              title: 'Facility Viewer',
              type: 'item',
              url: '/facility-viewer'
            }
          ]
        }
      ]
    }
  ]
};

export default consultantMenu;
